<template>
  <div>
    <template v-if="renderMessage">
      <span>{{ renderMessage }}</span>
      <br /><br />
    </template>
    <BetItems v-if="meta.isBet" :transactions="meta.options" :view-only="viewOnly" @input="onSelect" />
    <TransactionItems
      v-else
      :transactions="meta.options"
      :transaction-type="meta.type"
      :view-only="viewOnly"
      @input="onSelect"
    />
  </div>
</template>

<script lang="ts">
import { switcher } from '@/common/bot/flow-frameworks/switcher';
import { RequestUserTransactionMessage as RequestUserTransactionMessageType } from '@/common/bot/types/messages/RequestUserTransactionMessage';
import { TransactionType } from '@/common/config';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import TransactionItems from './Transactions/TransactionItems.vue';
import BetItems from './Transactions/BetItems.vue';
import { buildExternalEvent } from '@/common/bot/lib/event.factory';
import { ExternalBotEvent } from '@/common/bot/enum/ExternalBotEvent';
import { UserInputSubmittedTransactionEvent } from '@/common/bot/types';

@Component({
  components: {
    CustomerSupportIcon,
    TransactionItems,
    BetItems,
  },
})
export default class RequestUserTransactionMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: RequestUserTransactionMessageType;
  /**
   * This component can be reused for selection as well as for viewing items.
   */
  @Prop(Boolean) readonly viewOnly!: boolean;

  get meta() {
    const type = switcher<string, TransactionType>()
      .when('DEPOSITS', () => TransactionType.Deposit)
      .when('WITHDRAWALS', () => TransactionType.Withdrawal)
      .when('BETS', () => TransactionType.Bet)
      .match(this.message.transactionKind);

    return {
      type,
      options: this.message.options,
      isBet: type === TransactionType.Bet,
    };
  }

  get renderMessage() {
    if (this.viewOnly) {
      return this.$t('chat.user.issue.part');
    }
    return this.message.message;
  }

  onSelect(selected: UserInputSubmittedTransactionEvent['payload']) {
    if (this.viewOnly) return;
    const event = buildExternalEvent<UserInputSubmittedTransactionEvent>({
      type: ExternalBotEvent.USER_SUBMIT_INPUT_TRANSACTION,
      payload: selected,
    });

    this.$emit('send:event', event);
  }
}
</script>

<style scoped lang="scss">
.categories {
  .item {
    svg,
    span {
      margin: 0 0 0 8px;
    }
  }
}

.restart-text {
  display: block;
  margin-top: 16px;
}
</style>
